// extracted by mini-css-extract-plugin
export var autocompleteStyle = "SearchBar-module--autocompleteStyle--6be39";
export var drawerClassStyle = "SearchBar-module--drawerClassStyle--20b47";
export var portalClassStyle = "SearchBar-module--portalClassStyle--f49f0";